// This file contaisn functions to check user and learner polls and it is imported in the Dashboard

import { PollModal } from '@src/pages/Poll/PollModal.tsx'
import { POLL_STATUS, USER_JOURNEY } from '@src/utils/constants'
import { LearnerB } from '@src/logic/contexts/Learners/LearnersBackend.type'
import { PollModalF } from './Components/PollComponentType'

export const findFirstValidPoll = (polls?: PollModalF) => {
  if (!polls) return null
  return Object.entries(polls).find(([, poll]) => {
    const targets = poll.targetDevices ?? poll.target_devices ?? []
    return (poll.status === POLL_STATUS.NOT_INTRODUCED || poll.status === POLL_STATUS.IN_PROGRESS) && targets.includes('web_app')
  })
}

const getMostRecentLearner = (learners: LearnerB[]) => learners.reduce((latest, curr) => (new Date(curr.creation_info?.date || 0) > new Date(latest.creation_info?.date || 0) ? curr : latest))

export const checkUserPolls = (currentUser: any, currentUserPolls: PollModalF, showModal: (modal: React.ReactNode) => void) => {
  if (!currentUserPolls) return

  const firstPollEntry = findFirstValidPoll(currentUserPolls)

  if (firstPollEntry) {
    const [pollId, poll] = firstPollEntry
    showModal(<PollModal poll={poll} pollId={pollId} resourceId={currentUser.id} pollScope='USER' backToPath='/?fromPoll=true' />)
  }
}

/**
 * Show learner-level polls (when user journey is filling placement).
 */
export const checkLearnerPolls = async (currentUser: any, dataProvider: any, showModal: (modal: React.ReactNode) => void) => {
  if (!currentUser || currentUser.userJourney !== USER_JOURNEY.FILLING_PLACEMENT) {
    return false
  }

  try {
    const { data: learnersData } = await dataProvider.getList<LearnerB>('Learner', {
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'last_name', order: 'ASC' },
      filter: { state: 'active', selection: 'all' },
    })

    if (!learnersData || learnersData.length === 0) {
      return false
    }

    const mostRecentLearner = getMostRecentLearner(learnersData)
    const assignedPolls = mostRecentLearner?.assigned_polls as any

    if (!assignedPolls) {
      return false
    }

    const firstPollEntry = findFirstValidPoll(assignedPolls)

    if (!firstPollEntry) {
      return false
    }

    if (firstPollEntry) {
      const [pollId, poll] = firstPollEntry

      const mappedPoll = {
        pollTemplateId: poll.poll_template_id,
        requirementLevel: poll.requirement_level,
        allowedUsers: poll.allowed_users ?? [],
        targetDevices: poll.target_devices ?? [],
        status: poll.status ?? '',
        lastQuestion: poll.last_question ?? '',
        lastUpdate: poll.last_update ?? '',
      }

      showModal(<PollModal poll={mappedPoll} pollId={pollId} resourceId={mostRecentLearner.id} pollScope='LEARNER' backToPath={`/Learner/${mostRecentLearner.id}/show/goal`} />)
      return true
    }
  } catch (error: any) {
    return false
  }
}
